module.exports = __webpack_public_path__ + "static/media/IMG_2888-min.6305db5b.JPG";